module.exports = __webpack_public_path__ + "img/1571760285.21e843d1.jpg";